import * as React from 'react';

const MenuIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height={45} viewBox="0 0 24 24" width={45} xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M20 12H10" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} />
        <path d="M20 5H4" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} />
        <path d="M20 19H4" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} />
    </svg>
);
export default MenuIcon;
